import React from 'react';
import { priceunit } from '../client-config';
import { DISCOUNT_COLORS } from '../../lib/constants';
import { IPriceDisplayProps } from '../../lib/types';
import { formatPrice } from '../../utils/format-price';

export const PriceDisplay: React.FC<IPriceDisplayProps> = ({
  originalPrice,
  discountedPrice,
  hasDiscount,
  isOrderSummary = false,
}) => {
  const fontSize = isOrderSummary ? '16px' : undefined;
  const strikethroughStyle: React.CSSProperties = {
    textDecoration: 'line-through',
    color: DISCOUNT_COLORS.BRAND_RED,
    marginRight: '8px',
    fontSize,
  };
  const priceStyle: React.CSSProperties = { fontSize, fontWeight: 700 };

  if (hasDiscount) {
    return (
      <>
        <span style={strikethroughStyle}>
          {priceunit}{formatPrice(originalPrice)}
        </span>
        <span className='original-value' style={priceStyle}>
          {priceunit}{formatPrice(discountedPrice)}
        </span>
      </>
    );
  }

  return (
    <span className='original-value' style={priceStyle}>
      {priceunit}{formatPrice(discountedPrice)}
    </span>
  );
};
